import { useDispatch } from 'react-redux'
import { DynamicActionInfo } from 'types/ui/DynamicActionInfo'

export function usePerformDynamicAction() {
  const dispatch = useDispatch()
  return (action: DynamicActionInfo) => {
    if (action.callback) {
      action.params = action.params ? action.params : []
      action.callback.apply(null, action.params)
    }
    if (action.docEvent) {
      document.dispatchEvent(new CustomEvent(action.docEvent, { detail: action }))
    }
    if (action.reduxPayload) dispatch(action.reduxPayload)
    if (action.href) window.open(action.href, '_blank', 'noopener noreferrer')
  }
}
